import api from "../services/api-service";

class CourseTopicService {
  createTopic(body) {
    try {
      return api.post({
        url: "course-topics/create-topic",
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  normalizeConfigId(id) {
    if (id == null || id === "") return null;
    if (typeof id === "object" && id._id != null) {
      return this.normalizeConfigId(id._id);
    }
    const sid = String(id).trim();
    if (!sid || sid === "[object Object]") return null;
    return sid;
  }
  getAllTopics(configuration_id, search, instructor_id, page, limit) {
    try {
      let url = "course-topics/get-all-topics?";
      
      // Handle configuration_id (array or single) — always stringify real IDs
      if (Array.isArray(configuration_id)) {
        configuration_id.forEach((id) => {
          const sid = this.normalizeConfigId(id);
          if (sid) url += `configuration_id[]=${encodeURIComponent(sid)}&`;
        });
      } else if (configuration_id) {
        const sid = this.normalizeConfigId(configuration_id);
        if (sid) url += `configuration_id=${encodeURIComponent(sid)}&`;
      }

      // Handle search
      if (search) {
        url += `search=${search}&`;
      }

      // Handle instructor_id (array or single)
      if (instructor_id) {
        if (Array.isArray(instructor_id)) {
          instructor_id.forEach(id => {
            url += `instructor_ids[]=${id}&`;
          });
        } else {
          url += `instructor_ids[]=${instructor_id}&`;
        }
      }

      // Handle pagination
      if (page) {
        url += `page=${page}&`;
      }
      if (limit) {
        url += `limit=${limit}&`;
      }

      return api.get({
        url: url.endsWith('&') ? url.slice(0, -1) : url,
        // Params emptied as we built the URL manually to ensure format
      });
    } catch (error) {
      return new Error(error);
    }
  }
  updateTopic(id, body) {
    try {
      return api.put({
        url: `course-topics/update-topic/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  deleteTopic(id, body) {
    try {
      return api.delete({
        url: `course-topics/delete-topic/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getTopic(id) {
    try {
      return api.get({
        url: `course-topics/get-topic/${id}`,
      });
    } catch (error) {
      return new Error(error);
    }
  }
}
export default new CourseTopicService();
